export default (template = '', args = []) => template.replace(/%s/g, args.shift.bind(args));
